import {IToJson} from '@toolify/client/src/types/IToJson'
import {
  IFileResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IFileResponseInstance'

export function mapFileResponseInstance(
  file: IToJson<IFileResponseInstance>,
): IFileResponseInstance {
  return {
    ...file,
  }
}
